'use client';

import React from 'react';
import { EVENTS } from '@/constants/tracking';
import { TolstoyService } from '@/features/integrations';
import { TolstoyIntegration } from './TolstoyIntegration';

const INTEGRATION_STEPS = [
  'Add Tolstoy to your Shopify store.',
  'Once in Tolstoy, your videos will all automatically be available in the Library tab.',
  'Create an email abandonment flow project in Tolstoy.',
  'Copy the code from Tolstoy and paste it into your Klaviyo email template.',
];

const EMAIL_SUMMARY =
  'Easily embed your Bunu videos in your emails to increase open rates, click-throughs, and engagement.';

const EXAMPLES = [
  {
    src: '/assets/email-abandonment-flow-example-1.png',
    alt: 'Product showcase in email',
  },
  {
    src: '/assets/email-abandonment-flow-example-2.png',
    alt: 'Trigger when product is viewed',
  },
];

const PublishEmail: React.FC = () => {
  return (
    <TolstoyIntegration
      title="Automatically display your product videos in any email flow, for free."
      summary={EMAIL_SUMMARY}
      integrationSteps={INTEGRATION_STEPS}
      examples={EXAMPLES}
      publishEvent={EVENTS.PUBLISH_IN_EMAIL_WITH_TOLSTOY}
      getTolstoyEvent={EVENTS.GET_TOLSTOY_TO_PUBLISH_IN_EMAIL}
      redirectRoute={TolstoyService.Routes.EmailCreate}
    />
  );
};

export default PublishEmail;
